import { AppSettings } from './app.settings';
export class ConfirmPaymentSettings{
    public static GET_RESUME = `${AppSettings.BASE_URL}/api/transaction/paymentResume`;
    public static GET_VOUCHER = `${AppSettings.BASE_URL}/api/transaction/getVoucher?token=:token`;
}